// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#shu-booking-form .button-list{width:100%;margin-bottom:-0.5em}#shu-booking-form .button-list__button-like{display:inline-block}#shu-booking-form .button-list .button,#shu-booking-form .button-list .button-list__button-like{margin-bottom:0.5em}#shu-booking-form .button-list--align-left{text-align:left}#shu-booking-form .button-list--align-center{text-align:center}#shu-booking-form .button-list--align-right{text-align:right}\n", ""]);
// Exports
module.exports = exports;
